// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3049":"3b50cad41d76f4d02413","4903":"84f7614067d0dc160baf"}[chunkId] + ".js";
};